// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

// 应用列表查询接口
export const getAppList = (data?: any) => request(`/${serveName}/app/dimension`, null, 'POST_JSON', data)

// 筛选项下拉列表查询接口
export const getAllFilters = (data: any) => request(`/${serveName}/paid/event/filters`, null, 'POST_JSON', data)

// 通过 dbtId 查询支付渠道
export const getPayChnlByDbtIds = (data: any) =>
  request(`/${serveName}/app/getPayChnlByDbtIds`, null, 'POST_JSON', data)

// 监控数据看板
export const getMonitorData = (data: any) => request(`/${serveName}/metrics/selectPayMetrics`, null, 'POST_JSON', data)

// 获取监控数据看板下拉项
export const getMonitorFiltes = (data: any) => request(`/${serveName}/metrics/filters`, null, 'POST_JSON', data)
